// extracted by mini-css-extract-plugin
module.exports = {"cardFooter":"DataItems_cardFooter__18no1","buttons":"DataItems_buttons__L-Jcs"};